import { render, staticRenderFns } from "./ListPages.vue?vue&type=template&id=1fadf822"
import script from "./ListPages.vue?vue&type=script&lang=js"
export * from "./ListPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports